import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import { theme } from "@pallet-hq/hegel"
import Image from "components/Image"
import parse, { Element, HTMLReactParserOptions } from "html-react-parser"
import { PostDescription_post } from "__generated__/PostDescription_post"

const PostDescriptionFragment = gql`
    fragment PostDescription_post on PostType {
        description
    }
`

type PostDescriptionProps = {
    post: PostDescription_post
}

const parserOptions: HTMLReactParserOptions = {
    replace: domNode => {
        if (domNode instanceof Element && domNode.name === "img") {
            return (
                <Image
                    src={domNode.attribs.src}
                    alt={domNode.attribs.alt}
                    maxWidth="100%"
                    colorSlug="red"
                />
            )
        }
        if (domNode instanceof Element && domNode.attribs.style) {
            delete domNode.attribs.style
            return domNode
        }
    },
}

const PostDescription = (props: PostDescriptionProps) => {
    return (
        <DescriptionArea>
            {parse(props.post.description!, parserOptions)}
        </DescriptionArea>
    )
}

const DescriptionArea = styled.div`
    margin: ${theme.space.small} 0px;
    border: 1px solid transparent;
    border-radius: ${theme.space.xsmall};
`

PostDescription.fragment = PostDescriptionFragment

export default PostDescription
